var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "admin-store") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14H3.33333M14 14H12.6667M3.33333 14H12.6667M3.33333 14V6.21892M12.6667 14V6.21892M3.33333 6.21892C3.30866 6.20466 3.28434 6.18956 3.2604 6.1736L2.90016 5.93344C2.37554 5.58369 2.16762 4.91427 2.40179 4.32885L2.99808 2.83815C3.20056 2.33193 3.69084 2 4.23604 2H11.764C12.3092 2 12.7994 2.33194 13.0019 2.83815L13.5982 4.32885C13.8324 4.91427 13.6245 5.58369 13.0998 5.93344L12.7396 6.1736C12.7157 6.18956 12.6913 6.20466 12.6667 6.21892M3.33333 6.21892C3.77025 6.47132 4.31567 6.45622 4.7396 6.1736L6 5.33333L7.2604 6.1736C7.70827 6.47218 8.29173 6.47218 8.7396 6.1736L10 5.33333L11.2604 6.1736C11.6843 6.45622 12.2298 6.47132 12.6667 6.21892",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33341 13.9987V10.6654C9.33341 9.92898 8.73646 9.33203 8.00008 9.33203V9.33203C7.2637 9.33203 6.66675 9.92898 6.66675 10.6654V13.9987",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminStore);
export default __webpack_public_path__ + "static/media/admin-store.26144a0b8024c67657a666f03248fe01.svg";
export { ForwardRef as ReactComponent };